import { render, staticRenderFns } from "./BrandsTable.vue?vue&type=template&id=f91dbab6&"
import script from "./BrandsTable.vue?vue&type=script&lang=js&"
export * from "./BrandsTable.vue?vue&type=script&lang=js&"
import style1 from "./BrandsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports